// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3uvsI","alert":"SettungsInbox_alert__owo1y"};